import { SocialIcons } from '@/ui';
import { getSocialUIBlockData } from '@lib/server';
import { SocialWithContact } from '@types';

import { BlockBase } from './utils';

export async function Socials({
  show,
  params,
  id,
}: {
  show: { value: keyof SocialWithContact }[];
} & BlockBase) {
  const links = await getSocialUIBlockData(
    decodeURIComponent(params.domain),
    decodeURIComponent(params.venue || ''),
    show,
  );

  return <SocialIcons className="px-4 sm:px-8" id={id} links={links} />;
}
